module.exports = __webpack_public_path__ + "img/indiviual result icon.b5a6e648.svg";